import { SelectModel } from './select.model';
import { FormConfigBase } from './abstract/form-config-base.class';

export class TableRow extends FormConfigBase {
  guarantee: string;
  limit: string;
  extendGuarantee: SelectModel;
  included: {
    from: string;
    yes: {
      classNameIcon: ''
    }
    no: {
      classNameIcon: ''
    };
  };

  constructor( obj ) {
    super( obj );

    this.guarantee = obj.guarantee ? obj.guarantee : '';
    this.limit = obj.limit ? obj.limit : '';
    this.extendGuarantee = new SelectModel( obj.extendGuarantee );
    this.included = obj.included ? obj.included : {
      yes: {
        classNameIcon: ''
      },
      no: {
        classNameIcon: ''
      }
    };
  }
}
